import FormFieldsClientWrapper from './FormFieldsClientWrapper'

const page = () => {
    return (
        <div>
            <FormFieldsClientWrapper />
        </div>
    )
}

export default page